import React, {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import i18n from "../../../i18n";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import MediaDropButton from "../../Media/DropButton";
import projectQueries from "../../../queries/projectQueries";
import moment from "moment-business-days";
import FormAutocompleteGQL from "../../Form/FormAutocompleteGQL";
import swal from "sweetalert";
import projectMutations from "../../../mutations/projectMutations";
import {getMutationName, getQueryName} from "../../Form/utils";
import attachmentQueries from "../../../queries/attachmentQueries";
import attachmentReferenceMutations from "../../../mutations/attachmentReferenceMutations";
import FormField from "../../Form/FormField";

const getStatusId = async (event) => {
    if(event) {
        const query = projectQueries.getProjectStatus;
        const queryName = getQueryName(query).toLowerCase();
        const {data: result} = await window.apolloClient.query({query, variables: {event: event}});

        return result[queryName] && result[queryName].id;
    }
    return event;
}

const getBuilderData = values => {
    return values.buildings[0] &&
        values.buildings[0].building.parent &&
        (values.buildings[0].building.parent.builder || null);
}

const updateProjectData = async (data) => {
    const mutation = projectMutations.updateProject ;
    const mutationName = getMutationName(mutation);

    let statusId = await getStatusId('defects_eliminated');

    if(statusId) {
        data.status_id = statusId;
    }

    const {data: result} = await window.apolloClient.mutate({mutation, variables: {...data}});
    return result[mutationName];
}

const saveAttachment = async (fileData, projectId) => {

    const query = attachmentQueries.findAttachmentReference;
    const queryName = getMutationName(query);
    const variables = {id:fileData.id}

    const{data:reference} = await window.apolloClient.query({ query, variables, errorPolicy: "all"});
    const data = reference[queryName] || null;
    const attachmentReferences = data['attachmentReferences'] || null;
    const fileId = data.file_id;

    const referenceExists = attachmentReferences &&
        attachmentReferences.length &&
        attachmentReferences.find(ref =>
            ref.project_id !== null &&
            ref.project_id === parseInt( projectId ) &&
            fileId === fileData.sHash
        );

    if(!referenceExists) {

        const mutation = attachmentReferenceMutations.createAttachmentReference;
        const {data: result} = await window.apolloClient.mutate({mutation, variables: { project_id: parseInt( projectId ) , attachment_id: fileData.id}, errorPolicy: "all"});

        return result['createAttachmentReference'];
    } else {
        return {file_id: fileId,...referenceExists};
    }
};

const attachFiles = async (files,projectId) => {

    let attachedFiles = [];
    if (files && files.length > 0) {
        for (const file of files) {
            let attachment = await saveAttachment(file, projectId)
            attachedFiles.push( attachment.attachment_id );
        }
    }
    return attachedFiles;
}

const saveProjectData = async (values,saveOnly) => {

    const projectId = values.id || null;
    const defectsEliminated = moment(values.defects_eliminated).isValid()
        ? moment(values.defects_eliminated).format('YYYY-MM-DD HH:mm:ss')
        : null;

    const data = projectId &&
        await updateProjectData({ id: projectId, defects_eliminated: defectsEliminated })
    const files = await attachFiles( values.files, projectId );
    const builder = getBuilderData(values);

    const send = await axios.post(`/send-mail/${projectId}`,{
        type: 'defects_eliminated',
        attachments:files,
        builder:builder,
        apartment: values.buildings[0].apartment,
        building: values.buildings[0].building,
        deficiency: values.name,
        number_internal: values.number_internal,
        number_client: values.number_client,
        subcontractor: values.contacts[0].contact,
        defects_eliminated: defectsEliminated,
    });

    if(send && send.data && send.data.failures) {
        console.debug( send, builder);
    }
    return data;
}


const updateProject = (values,saveOnly) => {
    //@todo show info about rendered pdf like in form
    const builder = getBuilderData(values);

    return swal({
        text:`Mangel ${values.number_internal} erhält den Status "Freimeldung"`
            + (saveOnly
                ? ' und wird gespeichert'
                : `, wird gespeichert und versendet an: "${ builder
                        && (builder.company_name + '" ( ' + (builder.email ? builder.email : 'keine E-Mail Adresse!!!') + ')')
                  }`
                ),
        button: {
            text: "ok",
            closeModal: false,
            value: !!builder.email,
        },
        closeOnClickOutside: saveOnly && builder.email,
        closeOnEsc: saveOnly && builder.email,
    }).then(async res => {
        if (res) {
            const data = await saveProjectData(values,saveOnly);
            if (data) {
                return swal({
                    text: i18n.get('deficiency.defects_eliminated.saved'),
                    icon: 'success',
                    timer: 4000,
                }).then(() => {
                    if(data.id > 0) {
                        window.location.href = `/project/${data.id}`;
                    }
                });
            } else {
                return swal("Ooops!", "Da ist etwas schief gegangen!", "error");
            }
        } else {
            return swal(
                'Fehlende E-Mail-Adresse',
                'Die Freimeldung kann nicht über das System versendet werden',
                'error'
            );
        }
    });
}

const openSendDialog = (type) => {
    return swal({
        text: i18n.get('deficiency.dialog.send'),
        button: {
            text: "ok",
            closeModal: false,
        },
        closeOnClickOutside: false,
        closeOnEsc: false,
        allowOutsideClick: false,
    });
}

const DefectsEliminatedDialog = (props) => {

    const {
        classes,
        open,
        handleClose,
        closedStatusIds,
        uploadConfig,
    } = props;

    const [values,setValues] = useState(null);
    const [isExpired,setIsExpired] = useState(false);
    const [projectId,setProjectId] = useState('');

    const changeValues = data => {
        setValues({
            defects_eliminated: data.defects_eliminated || null,
            files: data.files || [],
            ...data,
        });
    }
    const changeIsExpired = e => setIsExpired(e);
    const changeProjectId = e => setProjectId(e);

    useEffect(() =>{
        setValues({id: null ,files:[]})
    },[setValues]);


    const closeDialog = () => {
        handleClose();
        changeProjectId('');
    }

    const handleSubmit = (saveOnly) => {
        closeDialog();
        updateProject(values,saveOnly).then();
    }

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={closeDialog}
                disableBackdropClick={true}
                className={classes.dialog}
                fullWidth={true}
                maxWidth={'sm'}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title" className={classes.dialogTitle}  disableTypography>
                    <Typography variant="h6" color={"primary"}>{i18n.get('deficiency.add_defect_eliminated_note')}</Typography>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={closeDialog}>
                        <Icon>close</Icon>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className={classes.dialogContent}>

                    <FormAutocompleteGQL
                        query={projectQueries.getOpenProjectsByNumber}
                        labelName={'name'}
                        valueName={'id'}
                        withoutValue={{status_id: closedStatusIds }} // without closed projects
                        name="project_id"
                        label={i18n.get('project.deficiency.select')}
                        isClearable={true}
                        defaultOptions
                        mutateData={ data => data.number_internal + ' - ' + data.name }
                        onChange={selectedOption => {
                            if(selectedOption && selectedOption.entity) {
                                changeValues(selectedOption.entity)
                                changeProjectId(selectedOption.entity.id || '');
                                changeIsExpired(
                                    moment().isAfter( selectedOption.entity.second_grace_period )
                                );
                            } else {
                                changeProjectId('');
                                changeIsExpired(false);
                            }
                        }}
                    />

                    {projectId && uploadConfig && !isExpired && (
                        <React.Fragment>
                            <FormField
                                type="date"
                                name="defects_eliminated"
                                label={
                                    i18n.get('deficiency.date')
                                    + ' '
                                    + i18n.get('deficiency.dates.defects_eliminated')
                                }
                                onChange={(e) => {
                                    values.defects_eliminated = e.target.value;
                                    changeValues(values)}
                                }
                                value={values.defects_eliminated ? values.defects_eliminated : '' }
                                InputLabelProps={{shrink: true}}
                            />
                            <MediaDropButton
                                meta={{
                                    refType:'project',
                                    refId: values ? values.id : null,
                                    fileType:'defects_eliminated',
                                }}
                                uploadConfig={uploadConfig}
                                onNewFile={(file) => {
                                    values.files.push(file);
                                    changeValues(values);
                                }}
                                onFileRemoved = { fileToRemove => {
                                    values.files = values.files.filter(
                                        file => file.iId !== fileToRemove.iId
                                    );
                                    changeValues(values);
                                }}
                            />
                        </React.Fragment>
                    )}
                    {isExpired && (
                        <Typography color={"primary"} style={{marginTop:10}}>
                            {i18n.get('deficiency.events.second_grace_period')}
                        </Typography>
                    )}

                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    {projectId && values && moment().isAfter( values.second_grace_period )
                        ? (
                            <Button
                                component={'a'}
                                variant={'contained'}
                                color={'primary'}
                                size={'small'}
                                onClick={() => window.location.href = `/project/${projectId}/edit` }
                            >
                                {i18n.get('deficiency.edit')}
                            </Button>
                        )
                        : (
                            projectId &&
                            values.files.length &&
                            values.defects_eliminated &&
                            (!values.second_grace_period || moment().isBefore( values.second_grace_period )) &&
                            (
                                <React.Fragment>
                                    {!isExpired && (
                                        <Button
                                            component={'a'}
                                            variant={'contained'}
                                            color={'primary'}
                                            size={'small'}
                                            onClick={() => handleSubmit(false)}
                                        >
                                            {i18n.get('deficiency.save_and_send')}
                                        </Button>
                                    )}
                                    <Button
                                        component={'a'}
                                        variant={'contained'}
                                        color={'primary'}
                                        size={'small'}
                                        style={{marginLeft:10}}
                                        onClick={() => handleSubmit(true)}
                                    >
                                        {i18n.get('default.save')}
                                    </Button>
                                </React.Fragment>
                            )
                        )}
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
    },
    dialogContent: {
        overflow:'visible',
    },
    dialogActions: {
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
    },
});

export default (withStyles(styles)) (DefectsEliminatedDialog)
